import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Block, Link, Tooltip } from '@klp/design';
import { getRequiredConfig } from '@klpkonsern/appconfig';
import { generateRouteParams } from '@klpkonsern/routing';
import { useGetContractRegistrationStatisticsQuery } from '../services/rtkApi';
import { ContractToRegistrationSummaryStatistics } from '../components/ContractToRegistrationSummaryStatistics';
import type { ILevendeKontrakterParams } from '@klp/levendekontrakter/views/LevendeKontrakter';
import { LocalLoader } from '@klp/design/Loader';

import {
    ContractManagementRoutes,
    ContractManagementTabs,
} from '@forvalter/routing/Routes';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { usePortfolio } from '@klp/portfolio/store';
import { useCurrentUser } from '@klp/auth';

const useStyles = makeStyles(() => ({
    title: {
        textTransform: 'uppercase',
    },
}));

export default function ContractManagementSummaryView() {
    const classes = useStyles();
    const { currentUser, currentUserIsLoading, isEDAdmin } = useCurrentUser();
    const { portfolio } = usePortfolio();

    const newTabParams: ILevendeKontrakterParams = {
        autologin: true,
        hiddenNavbar: false,
    };

    const url = getRequiredConfig('WEBAPP_CONTRACT_FRAME_URL').concat(
        generateRouteParams(newTabParams),
    );

    const openLEKO = (destination: string) => () => {
        window.open(destination, 'Contracts');
    };

    const {
        data: contractToRegistrationStatistics,
        isLoading: contractStatisticsLoading,
        isFetching: contractStatisticsFetching,
    } = useGetContractRegistrationStatisticsQuery(
        {
            ansvarlig: isEDAdmin ? portfolio?.brukerId : currentUser?.epost,
        },
        { skip: !currentUser?.epost },
    );

    const isLoading = contractStatisticsLoading || contractStatisticsFetching;

    return (
        <>
            <Block
                marginTop="compact"
                display="inline"
                klpTypographyVariant="xsmall"
                className={classes.title}
                data-cy="ContractsExpiringSummary__yourAvailableLocales"
                translation="frontPage.contractManagement.subtitle"
            />{' '}
            &nbsp;
            <Tooltip
                translation="frontPage.contractManagement.infoText"
                title=""
            >
                <Illustration
                    icon={IconName.CIRCLE_INFO}
                    size="xsmall"
                    klpPalette="primary"
                />
            </Tooltip>{' '}
            <LocalLoader isLoading={isLoading || currentUserIsLoading}>
                <ContractToRegistrationSummaryStatistics
                    statistics={contractToRegistrationStatistics}
                    isOkonomi={currentUser?.isOkonomi}
                />
            </LocalLoader>
            <Block>
                <Link
                    target="_blank"
                    onClick={openLEKO(url)}
                    externalLink={true}
                    translation="frontPage.contractManagement.newProsessLink"
                />
            </Block>
            <Block paddingTop="compact">
                <Link
                    href={ContractManagementRoutes.tab(
                        ContractManagementTabs.registrering,
                    )}
                    translation="frontPage.contractManagement.actionButtonText"
                />
            </Block>
        </>
    );
}
